const calculateOverallProductSales = (joinedData, testProductData) => {
    const overallProductSales = [];

    joinedData.forEach(item => {
        item.buyers.forEach(buyer => {
            buyer.productNo.forEach((productNo, index) => {
                // 상품 번호에 해당하는 상품 정보 가져오기
                const product = testProductData.find(product => product.productNo === productNo);
                const productName = product ? product.productName : 'Unknown Product';
                const productSalesPrice = product ? product.productSalesPrice : 0;
                const productImageUrl = product ? product.productImg : '';

                // 매장 전체의 상품별 판매 정보 저장
                const existingProductIndex = overallProductSales.findIndex(item => item.productNo === productNo);
                if (existingProductIndex === -1) {
                    overallProductSales.push({
                        productNo,
                        productName,
                        totalQuantity: buyer.productCnt[index],
                        productSalesPrice,
                        productImageUrl
                    });
                } else {
                    overallProductSales[existingProductIndex].totalQuantity += buyer.productCnt[index];
                }
            });
        });
    });

    // totalQuantity를 기준으로 내림차순 정렬
    overallProductSales.sort((a, b) => b.totalQuantity - a.totalQuantity);

    return overallProductSales;
};

export default calculateOverallProductSales;